import React, {Component} from 'react';
import bankTheme from '../theme/bankTheme';
import InfoPage from '../containers/InfoPage'

class ThemeInfoPage extends Component {
  constructor(props) {
		super(props);
		this.state = {
			errorString: '',			
		};
		this.getInfo = this.getInfo.bind(this);
	}
  getInfo(){
    this.props.onCallBack();
  }

  render() {
    return (
     <div  >
      <InfoPage history = {this.props.history} nextPage='/thememain' errorString={this.props.errorString} reply={this.props.reply} onCallBack={this.getInfo}/>
    </div>
    );
  }
}

export default bankTheme((ThemeInfoPage));